export default ({ service, request, serviceForMock, requestForMock, mock, faker, tools }) => ({
  getAttributeData (data = {}) {
    return request({
      url: '/digitalCenter/inputTemplate/inputTemplateAttrList',
      method: 'post',
      data
    })
  }
})
